<template>
    <div class='employee-account'>
        <page-top :title="title" :background="'#35b72a'" >
            <div class="box is-radiusless is-borderless">
                <div class="container">
                    <div class="menu">
                        <ul>
                            <router-link tag="li" :to="{ name: 'users.account' }" exact>
                                <router-link :to="{ name: 'users.account' }" exact>
                                    <b-icon icon="account" />
                                    <span>{{$t('pages.users.account.title')}}</span>
                                </router-link>
                            </router-link>

                            <!--<router-link tag="li" :to="{ name: 'users.account', params: { section: 'settings' }}">-->
                                <!--<router-link :to="{ name: 'users.account', params: { section: 'settings' }}">-->
                                    <!--<b-icon icon="settings-box" />-->
                                    <!--<span>{{$t('pages.users.settings.title')}}</span>-->
                                <!--</router-link>-->
                            <!--</router-link>-->
                        </ul>
                    </div>
                </div>
            </div>
        </page-top>

        <div class="section">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="box is-shadowless is-radiusless is-paddingless"">
                            <user-avatar-editing-area />
                        </div>
                    </div>

                    <div class="column">
                        <div class="box is-shadowless is-radiusless is-paddingless"">
                            <user-email-password-area />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/variables';

    .employee-account {
        background: $background-blueish;

        .menu {
            -webkit-overflow-scrolling: touch;
            align-items: stretch;
            display: flex;
            font-size: 1rem;
            justify-content: space-between;
            overflow: hidden;
            overflow-x: auto;
            white-space: nowrap;

            ul {
                align-items: center;
                display: flex;
                flex-grow: 1;
                flex-shrink: 0;
                justify-content: flex-start;

                li {
                    display: block;

                    a {
                        &.is-active {
                            color: $primary;
                        }

                        color: $dark;

                        align-items: center;
                        display: flex;
                        justify-content: center;
                        padding: 0 1em;
                        vertical-align: top;
                    }
                }
            }
        }
    }
</style>

<script>
    import PageTop from '@/global/components/PageTop';
    import UserEmailPasswordArea from '@/taskflex/users/components/EmailPasswordArea';
    import UserAvatarEditingArea from '@/taskflex/users/components/UserAvatarEditingArea';

    export default {
        props: {
            params: {
                required: true,
            },
        },
        computed: {
            title() {
                switch (this.params.section) {
                    case 'settings':
                        return this.$t('pages.users.settings.title');
                    default:
                        return this.$t('pages.users.account.title');
                }
            },
        },

        components: {
            PageTop,
            UserEmailPasswordArea,
            UserAvatarEditingArea,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/employees/pages/Account.vue